import axios from "axios";
import {
  CHECKOUT_LOAD_ATTEMPT,
  CHECKOUT_LOAD_SUCCESS,
  CHECKOUT_LOAD_FAILED,
} from "../types/checkoutTypes";
import { config } from "../../config";

const url_api = config.api.godiway;

export function loading() {
  return { type: CHECKOUT_LOAD_ATTEMPT };
}

export function success(data) {
  return { type: CHECKOUT_LOAD_SUCCESS, data };
}

export function failed(error) {
  return { type: CHECKOUT_LOAD_FAILED, error };
}

export const loadSellerCheckout = (data: Object) => async (dispatch) => {
  dispatch(loading());
  try {
    const response = await axios.get(url_api + "seller/checkout", {
      params: { id: data.user_id, goder_id: data.goder_id },
      headers: { Authorization: `Bearer ${data.token}` },
    });

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(success(response.data.body));
      return { ok: true, data: response.data.body };
    }
    dispatch(failed(response.data.body || "try_later"));
    return { ok: false, error: response.data.body };
  } catch (error) {
    dispatch(failed("try_later"));
    return { ok: false, error: "try_later" };
  }
};
